import React, {
  useEffect, useState,
} from 'react';
import { Formik } from 'formik';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import { withLDConsumer } from 'launchdarkly-react-client-sdk';

import encode from '../../../../../shared/utils/encodeToUrl';
import getAllUrlParams from '../../../../../shared/utils/getAllUrlParams';
import { LoginSchema } from '../../../../../shared/utils/loginSchemaHelper';
import useLogin from '../../hooks/useLogin';
import SharedLoginForm from '../../shared/SharedLoginForm';

const LoginFormSSO = ({ flags }) => {
  const {
    handleLogin,
    handleLoginSSO,
  } = useLogin();

  const [googleLoginWidth, setGoogleLoginWidth] = useState('322');

  const location = useLocation();

  useEffect(() => {
    const urlParams = getAllUrlParams(window.location.href, false);
    const values = {
      client_id: process.env.CLIENT_ID,
      client_secret: process.env.CLIENT_SECRET,
      grant_type: 'sso_token',
      token: urlParams.token,
    };
    handleLoginSSO(encode(values), flags.registration);
  }, [location]);

  useEffect(() => {
    const handleResize = () => {
      setGoogleLoginWidth(window.innerWidth < 600 ? '270' : '322');
    };

    handleResize();
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <Formik
      initialValues={{
        client_id: process.env.CLIENT_ID,
        client_secret: process.env.CLIENT_SECRET,
        grant_type: 'password',
        password: '',
        scope: 'offline_access',
        username: '',
      }}
      onSubmit={(values) => {
        handleLogin(encode(values));
      }}
      validationSchema={LoginSchema}
      render={({
        errors,
        handleSubmit,
        touched,
        values,
      }) => (
        <SharedLoginForm
          errors={errors}
          googleLoginWidth={googleLoginWidth}
          handleSubmit={handleSubmit}
          isSSOLogin
          touched={touched}
          values={values}
        />
      )}
    />
  );
};

LoginFormSSO.propTypes = {
  flags: PropTypes.shape({
    registration: PropTypes.bool.isRequired,
  }).isRequired,
};

export default withLDConsumer()(LoginFormSSO);
